/**
 * Sorts reviews and comments according to the specified priority:
 * 1. Positive reviews with text (most recent first)
 * 2. Positive reviews without text (most recent first)
 * 3. Negative reviews with text (most recent first)
 * 4. Negative reviews without text (most recent first)
 * 5. Comments (most recent first)
 */
export const sortItemsByPriority = (items) => {
  const getPriority = (item) => {
    if (item.itemType === 'rating') {
      const hasReviewComment = Boolean(item.comment || item.content)

      if (item.score === 1) {
        // Positive reviews: with text = 0, without text = 1
        return hasReviewComment ? 0 : 1
      }

      if (item.score === -1) {
        // Negative reviews: with text = 2, without text = 3
        return hasReviewComment ? 2 : 3
      }
    }

    // Comments always have priority 4
    return 4
  }

  const getDateForSorting = (item) => {
    // Use updatedAt if available, otherwise use createdAt
    const dateString = item.updatedAt || item.createdAt
    return new Date(dateString).getTime()
  }

  return items.sort((a, b) => {
    const priorityA = getPriority(a)
    const priorityB = getPriority(b)

    // First sort by priority
    if (priorityA !== priorityB) {
      return priorityA - priorityB
    }

    // Within same priority, sort by date (most recent first)
    const dateA = getDateForSorting(a)
    const dateB = getDateForSorting(b)
    return dateB - dateA
  })
}

export default sortItemsByPriority
